import React from "react";
import FadeIn from "./FadeIn";

const ProseSection = ({ children, highlight = false, className = "" }) => (
  <section className={`ku-section ${highlight ? "bg-ku-gradient-soft" : "bg-white"} ${className}`}>
    <div className="ku-container max-w-4xl">
      <FadeIn>
        <div className="ku-prose">{children}</div>
      </FadeIn>
    </div>
  </section>
);

export default ProseSection;
